var params = new URLSearchParams(window.location.search);
if (params) {
    // If 'quiz-result' exists without value (e.g. ?quiz-result) treat as true
    if (params.has('quiz-result')) {
      var quizSegment = document.getElementById('quiz-banner');
      if (quizSegment) {
        quizSegment.style.display = '';
      }
    }
}